import { BRAND_LIST } from 'typings'
import * as Typings from '../typings'

const TaiwanLocale: Typings.LocaleType = {
  REGION: Typings.RegionGroupNames.ASIA,
  CODE: 'tw',
  LANGUAGE_CODE: 'zh',

  LONG_NAME: 'Taiwan',
  SHORT_NAME: 'TW',

  DISPLAY_NAME: '台灣',
  DISPLAY_COUNTRY: '台灣',

  LANGUAGES: {
    ZH: 'zh',
  },

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 33.92920123358008,
    INITIAL_LONGITUDE: 138.42930714999994,
    INITIAL_ZOOM: 4,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {},

  HOME_PAGE_URL: 'https://www.uniqlo.com',

  MAP_URL: 'https://www.uniqlo.com/tw/stores/',
  MAP_MOBILE_URL: 'https://map.uniqlo.com/tw/zh/',

  TERMS_OF_USE_URL: 'https://www.uniqlo.com',
  PRIVACY_POLICY_URL: 'https://www.uniqlo.com',

  POSTCODE_FORMAT: /[0-9]{3}(-[0-9]{2})?/g,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  AM_FORMAT: ' AM',
  PM_FORMAT: ' PM',
}

export default TaiwanLocale
